import {useEffect, useRef} from "react";
import popup_close from "../assets/popup-close.svg"

const getYoutubeId = (video) => {
    if (!video) return "";
    if (/^[\w-]{11}$/.test(video)) return video;

    try {
        const url = new URL(video);
        const queryId = url.searchParams.get("v");
        if (queryId) return queryId;

        const pathMatch = url.pathname.match(/\/(?:embed|shorts|live)\/([\w-]{11})/);
        if (pathMatch) return pathMatch[1];

        const shortId = url.pathname.replace("/", "");
        if (/^[\w-]{11}$/.test(shortId)) return shortId;
    } catch (e) {
        return "";
    }

    return "";
};

const YoutubePlayerPopup = ({open, onClose, videoUrl, videoId, title = "Video"}) => {
    const onCloseRef = useRef(onClose);
    const closeButtonRef = useRef(null);
    onCloseRef.current = onClose;

    const resolvedId = videoId || getYoutubeId(videoUrl);

    useEffect(() => {
        if (!open) return undefined;

        const onKeyDown = (event) => {
            if (event.key === "Escape") onCloseRef.current();
        };

        document.addEventListener("keydown", onKeyDown);
        const previousOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        closeButtonRef.current?.focus();

        return () => {
            document.removeEventListener("keydown", onKeyDown);
            document.body.style.overflow = previousOverflow;
        };
    }, [open]);

    if (!open || !resolvedId) return null;

    const src = `https://www.youtube.com/embed/${resolvedId}?autoplay=1&rel=0&playsinline=1`;

    return (
        <>
            <div className="page-mask youtube-player-mask" onClick={() => onCloseRef.current()}/>
            <div
                className="youtube-player-popup"
                role="dialog"
                aria-modal="true"
                aria-label={title}
            >
                <button
                    type="button"
                    className="youtube-player-popup-close"
                    onClick={() => onCloseRef.current()}
                    aria-label="Close video"
                    ref={closeButtonRef}
                >
                    <img src={popup_close} alt=""/>
                </button>
                <div className="youtube-player-popup-frame">
                    <iframe
                        src={src}
                        title={title}
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen
                    />
                </div>
            </div>
        </>
    )
}

export default YoutubePlayerPopup
